// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".assignee[data-v-0eb40392]{font-size:18px;color:#333;border-bottom:solid 1px #c9c9c9;margin-bottom:5px;padding-bottom:5px}.assignee .fa[data-v-0eb40392]{font-size:22px}\n", ""]);
// Exports
module.exports = exports;
